<template>
  <div class="mini-product" :class="[shouldFavHover && !favorite && 'hover', fullWidth && 'full-width']">
    <a :href="product.url" class="product-link">
      <div class="product-image">
        <responsive-image :lazy="false" :image="product.productImage" :widths="[130]" />
      </div>
      <div class="product-info">
        <h2 class="product-title no-transform">{{ product.title }}</h2>
        <div v-if="showVariations">
          <span class="product-variation" v-if="product.swatchImage">
            <responsive-image :lazy="false" :image="product.swatchImage" :widths="[12]" /> </span
          ><span class="product-variation" v-for="(variation, index) in product.variations" :key="index">
            <responsive-image :lazy="false" :image="variation.swatchImage" :widths="[12]" />
          </span>
        </div>
        <div class="product-price bold accent">
          <div class="originalPrice" v-if="product.isOnSale || product.isOnClearance">{{ product.originalPrice }}</div>
          <div class="newPrice">{{ product.price }}</div>
        </div>
      </div>
    </a>
    <div class="favorite-container">
      <div class="favorite" v-if="favoritable" @click="onFavoriteClicked($event)">
        <span class="af af-heart-full" v-if="favorite"></span>
        <span class="af af-heart" v-else></span>
      </div>
    </div>
  </div>
</template>
<script>
import { isTouch, checkFavorite } from '../utils/Utils.js';
import Image from './Image.vue';

export default {
  name: 'MiniProduct',
  components: {
    ResponsiveImage: Image,
  },
  props: {
    product: Object,
    badge: {
      type: Boolean,
      default: true,
    },
    showVariations: {
      type: Boolean,
      default: true,
    },
    spaceBottom: {
      type: Boolean,
      default: true,
    },
    viewdFn: {
      type: Function,
    },
    favorites: {
      type: Object,
    },
    favoritable: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      favorite: false,
      shouldFavHover: !isTouch(),
    };
  },
  created() {
    this.checkFavorite(this.product);
  },
  methods: {
    onFavoriteClicked(event) {
      this.favorite = !this.favorite;
      this.$emit('favoriteClick', {
        product: Object.assign({}, this.product),
        value: this.favorite,
        target: event.target,
      });
    },

    checkFavorite(product) {
      if (product) {
        this.favorite = checkFavorite(product.id, this.favorites);
      }
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.mini-product {
  position: relative;
  display: flex;

  &.hover {
    @media (min-width: $tablet-breakpoint) {
      .favorite-container {
        .favorite {
          opacity: 0;
          transition: opacity 150ms ease-out, transform 200ms ease-out;
        }
      }

      /* purgecss ignore */
      &:hover {
        .favorite {
          opacity: 1;
        }
      }
    }
  }

  &.full-width {
    width: 100%;
    justify-content: space-between;
    box-sizing: border-box;

    .product-link {
      .product-info {
        .product-title {
          font-size: 0.9em;
          padding-top: 5px;
        }
      }
    }

    .favorite {
      margin-top: 4px;
      margin-right: 4px;
    }

    @media (max-width: calc($mobile-breakpoint - 1px)) {
      padding-left: 3%;
      padding-right: 4%;

      .favorite {
        margin-right: -1px;
      }
    }
  }

  .product-link {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;

    .product-image {
      margin-right: 10px;
      flex-basis: 40%;
      transition: transform 200ms ease-out;

      /* purgecss ignore */
      &:hover {
        transform: scale(1.05);
      }
    }

    .product-info {
      display: flex;
      flex-direction: column;
      flex-basis: 60%;
      margin-bottom: 4px;
      padding-top: 2px;

      .product-variation {
        margin-right: 4px;
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        width: 12px;
        height: 12px;
      }

      .product-title,
      .product-price {
        margin-bottom: 4px;
      }

      .product-title {
        font-size: var(--font-size-14);
        line-height: var(--line-height-14);
      }

      .product-price {
        font-size: var(--font-size-12);
        line-height: var(--line-height-12);
        display: flex;
        line-height: 12px;
        text-align: right;
        color: var(--accent-color);
        margin-bottom: 10px;
        .originalPrice {
          margin-right: 8px;
          font-size: 1.1em;
          text-decoration: line-through;
          color: var(--grey-medium);
        }
        .newPrice {
          font-family: var(--font-bold);
          font-size: var(--font-size);
        }
      }
    }
  }

  .favorite-container {
    .favorite {
      padding: 8px;
      cursor: pointer;
      flex-basis: 16px;

      transition: transform 200ms ease-out;

      /* purgecss ignore */
      &:hover {
        transform: scale(1.2);
      }

      .af {
        font-size: 1.3em;
      }

      .af-heart-full {
        color: var(--accent-color);
      }
    }
  }
}
</style>
